import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaLock, FaUserAlt } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";

import { Page, Input } from "ui/components";
import signin from "../../../assets/signin.png";
import { Auth } from "services/action";

import { googleLogout } from "@react-oauth/google";

const SigninScreen = ({ location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");

  const $handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      username: username,
      password: password,
      app: "driver",
    };

    await Dispatch(Auth.$signin(payload));
  };

  React.useEffect(() => {
    googleLogout();
  }, []);

  return (
    <Page className="bg-container-image position-relative">
      <div className="mt-3 mb-3 d-flex align-items-center justify-content-center">
        <img src={signin} alt="" height={200} />
      </div>

      {location?.state?.is_reset ? (
        <div className="bg-warning-lt text-center p-2 border-warning border rounded mt-2 mb-2">
          <div className="text-secondary fs-6">
            <div>
              Reset Password berhasil, silakan masuk menggunakan kata sandi baru
              anda
            </div>
          </div>
        </div>
      ) : null}

      <div>
        <div style={{ fontSize: 20, fontWeight: 700, textAlign: "left" }}>
          Masuk ke Akun Anda
        </div>
        <div className="mt-2 mb-2" style={{ textAlign: "left" }}>
          Silahkan isi username dan kata sandi anda
        </div>
        <form onSubmit={$handleSubmit}>
          <div className="form-group mb-3 ">
            <Input
              icon={<FaUserAlt />}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              type="text"
              placeholder="masukkan username anda"
              error={StateForm?.errors?.username}
              lg
            />
          </div>
          <div className="form-group mb-3 ">
            <Input
              icon={<FaLock />}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="masukkan kata sandi anda"
              error={StateForm?.errors?.password}
              lg
            />
          </div>
          <div className="page-pretitle text-primary mt-2 text-end cursor-pointer">
            <span onClick={() => History.push("/forget-password")}>
              Lupa Password ?
            </span>
          </div>

          <Button
            type="submit"
            variant="primary"
            className="w-100 mt-3 p-2 border border-primary"
            disabled={StateForm?.loading}
          >
            {!StateForm?.loading ? (
              "Masuk"
            ) : (
              <div className="spinner-border" role="status"></div>
            )}
          </Button>
        </form>
      </div>

      <div
        style={{ textAlign: "center" }}
        className="px-3 position-absolute bottom-0 start-50 translate-middle-x w-100 mb-3 mt-2"
      >
        <small>
          Dengan masuk dan mendaftar, anda menyetujui{" "}
          <b>syarat &amp; ketentuan </b>
          yang berlaku dan <b>kebijakan privasi</b>.
        </small>
      </div>
    </Page>
  );
};

export default SigninScreen;
